export { default } from './FattyPattyMenuCard';
